import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import UniboxThemeProvider from "./UniboxThemeProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <UniboxThemeProvider>
    <App />
  </UniboxThemeProvider>
);
